import React from 'react';
import t from "../../../../../helpers/t";
import {moment} from "../../../../../../../vendor";
import {Biscuit} from "../../../../../../utils";
import {rbac} from "../../../index";
import MessageTooltip from "../MessageTooltip";

const WebView = (props) => {
    const {message, index, deleteMessagePending, onDeleteMessage, currentUrl, handleOpenMultipleRecipientsDialog, getNameOfRecipient, getUserIdOfRecipient, getNameOfUsergroup, onChangeStatusMessage } = props;
    return (
        <>
            <div className="inb-c-item inb-c-item--message row hide-for-small-only" key={index}>
                {/* {Biscuit.get('user.is_superuser')  === 'true' &&  <aside className="inb-c-item__actions">
                          <DropdownButton id="dropdown-basic-button" title="..." drop="right" menuAlign="right"
                                          bsPrefix="button round inb-toggle-contingent-dd hover">
                            <ul className="inb-dropdown__list">
                              <li data-inb-action-link='changelog' id="kln_changelog">
                                <Dropdown.Item href='#' onClick={() => openChangeLog(message.changeLogs)}>
                                  <i className="fi fi-wrench"> </i>
                                  {t('changelog', null, 'capital')}
                                </Dropdown.Item>
                              </li>
                            </ul>
                          </DropdownButton>


                        </aside>}*/}
                <div className="large-2 medium-7 small-7 column show-label" title={t('date',null,'capital')}>
                    <span>{moment(message.modified).format('DD.MM.YYYY HH:mm')}</span>
                </div>
                <div className="large-3 medium-7 small-7 column message-subject show-label" title={t('subject',null,'capital')}>
                    {message.subject.length >= 16 ?
                        <MessageTooltip
                            tooltip = {message.subject}
                            placement = "bottom-end"
                        >
                            {message.subject}
                        </MessageTooltip>
                        :
                        <span style={{cursor: "pointer"}}>{message.subject}</span>
                    }
                </div>
                <div className="large-1 medium-7 small-7 column order_nbr show-label" title={t('order_nbr',null,'capital')} style={{ cursor: 'pointer'}} >
                    {message.mtype === "email" && <a href={"/orders/"+message.order_nr+"/edit"}>{message.order_nbr !== null ? message.order_nbr : ""}</a>}
                </div>
                <div className="large-2 medium-7 small-7 column message-recipient show-label" title={t('recipient',null,'capital')} style={{ cursor: 'pointer'}} >
                          <span className="recipient-wrapper">
                            {
                                message.mtype === "email" ?
                                    <a href={`/users/${getUserIdOfRecipient((message.other_user_nr !== null?message.other_user_nr:message.user_nr)).userId}?path=/users${getNameOfRecipient((message.other_user_nr !== null?message.other_user_nr:message.user_nr)).roleRecipient !== "user" ? "/staff" : ""}`}>
                                        {getNameOfRecipient((message.other_user_nr !== null?message.other_user_nr:message.user_nr)).nameRecipient}
                                    </a>
                                    :
                                    message.user_group_id === null && message.recipient === null ?
                                        <span>{t("all")}</span>
                                        :
                                        message.user_group_id !== null && message.recipient === null ?
                                            <a href={"/usersExtension/userGroups/"+message.user_group_id+"/listUsers"}>{getNameOfUsergroup(message.user_group_id)}</a>
                                            :
                                            message.user_group_id === null && message.recipient !== null && message.recipient.split(";").length === 1 ?
                                                <a href={`/users/${message.recipient}?path=/users${getNameOfRecipient(message.recipient).roleRecipient !== "user" ? "/staff" : ""}`}>{getNameOfRecipient(message.recipient).nameRecipient}</a>
                                                :
                                                message.user_group_id === null && message.recipient !== null && message.recipient.split(";").length > 1 ?
                                                    <span onClick={() => handleOpenMultipleRecipientsDialog(message)}>{t("multiple")}</span>
                                                    : ""
                            }
                          </span>
                </div>
                <div className="large-1 medium-7 small-7 column message-type show-label" title={t('type',null,'capital')} style={{ cursor: 'pointer'}} >
                    <span>{t(message.mtype)}</span>
                </div>
                <div className="large-1 medium-7 small-7 column message-status show-label" title={t('message_status',null,'capital')} style={{ textTransfrom: 'capitalize', color: `${message.mstatus === 'success' ? '#009D06' : (message.mstatus === 'failed') ? '#CE0A0A' : '#000000'}`}}>
                    {message.mstatus === 'scheduled' ? (
                            <select
                                id="status-change"
                                type="text"
                                className="form-control"
                                name="statusChange"
                                required="" autoComplete="false"
                                onChange={(e) => onChangeStatusMessage(e, message)}
                            >
                                <option value="scheduled">{t('message_scheduled')}</option>
                                <option value="draft">{t('message_draft')}</option>
                            </select>
                        ) :
                        <span>{t('message_' + message.mstatus)}</span>
                    }
                </div>
                {(message.mtype !== "email" && message.mstatus !== "success") &&
                    <div className="medium-offset-0 medium-2 column item-button-group" style={{ flexWrap: "wrap", paddingLeft: "0.9375rem" }}>
                        <div className="button-container button-edit">
                            { rbac.hasPermission('editMessage') &&
                                <a
                                    href={"/usersExtension/messages/" + message.id + currentUrl.search}
                                    title={t('edit')}
                                    data-inb-action-link="edit">
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-edit"></div>
                                    </button>
                                </a>
                            }
                        </div>
                        {message.mstatus !== "failed" &&
                            <div className="button-container">
                                { rbac.hasPermission('deleteMessage') && <>
                                    {deleteMessagePending !== index ?<>
                                        <a
                                            href="#"
                                            className="inb-reservation__pdf2"
                                            title={t('delete')}>
                                            <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => onDeleteMessage(message)}>
                                                <div className="inb-fi-remove"></div>
                                            </button>
                                        </a> </>: <>
                                        <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                                    </>
                                    }</>}
                            </div>
                        }
                    </div>
                }
                {(message.mstatus === "success" ||
                        ((message.mstatus === "failed" || message.mstatus === "paused")
                            && message.mtype === "email")) &&
                    <div className="button-view-wrapper">
                        <div className="button-container button-view">
                            { rbac.hasPermission('viewMessage') &&
                                <a
                                    href={"/usersExtension/messages/" + message.id + "/view" + currentUrl.search}
                                    title={t('view')}
                                    data-inb-action-link="view">
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-eye"></div>
                                    </button>
                                </a>
                            }
                        </div>
                    </div>
                }
            </div>
        </>
    );
}

export default WebView;